import React from 'react';
import { Modal, Container, Row, Col } from 'reactstrap';

import { ApiContext } from 'src/utils/ApiContext';

export default (props) => {
    const { showModalWithdraw } = props;

    const context = React.useContext(ApiContext);

    return (
        <Modal
            isOpen={context.showWithdrawSelect}
            toggle={() => context.setShowWithdrawSelect(false)}
            zIndex={1}
        >
            <Container style={{ padding: 20, background: '#1E3845' }}>
                <Row className={'justify-content-center align-items-center'}>
                    <div style={{ color: 'whitesmoke' }}>{'請選擇提款的方式'}</div>
                </Row>

                <Row className={'justify-content-center align-items-center'}>
                    <Col xs={3}>
                        <button
                            className={'btn btn-outline-success my-2'}
                            onClick={() => {
                                showModalWithdraw();
                                context.setShowWithdrawSelect(false);
                            }}
                        >
                            E Pay
                        </button>
                    </Col>
                </Row>
            </Container>
        </Modal>
    );
};
